import './Shared/libs/jquery/jquery-ui.min.js';
//import './Shared/libs/jquery/jquery-ui-datepicker-settings.js';
import './Shared/libs/jquery.powertip/jquery.powertip.js';
import './Shared/libs/blockUI/jquery.blockUI.js';
import './Shared/libs/inputmask/inputmask.js';
import './Shared/libs/inputmask/jquery.inputmask.js';
import './Shared/libs/jquery.validate/jquery.validate.js';
import './Shared/libs/jquery.validate/jquery.validate.unobtrusive.js';
import './Shared/libs/jquery/jquery.nice-select.min.js';
import './Shared/Infrastructure/Localization';
import './Shared/Infrastructure/UiBlock';
import './Shared/Infrastructure/Utils';
import './Shared/Infrastructure/Ajax';
import './Shared/Infrastructure/Popup';
import './Shared/Infrastructure/Validators';
import './Shared/Infrastructure/Behaviours/BaseControlBehaviour';
import './Shared/Infrastructure/Behaviours/AjaxActionBehavior';
import './Shared/Infrastructure/Behaviours/NotificationBehaviour';
import './Shared/Infrastructure/Behaviours/EnterBehaviour';
import './Shared/Infrastructure/Behaviours/AutoFocusBehaviour';
import './Shared/Infrastructure/Behaviours/DatePickerBehaviour';
import './Shared/Infrastructure/Behaviours/InputMaskBehaviour';
import './Shared/Infrastructure/Behaviours/PagerBehaviour';
import './Shared/Infrastructure/Behaviours/ReplaceTagBehaviour';
import './Shared/Infrastructure/Behaviours/TooltipsBehaviour';
import './Shared/Infrastructure/Behaviours/RecaptchaBehaviour';
import './Shared/Infrastructure/Behaviours/PasswordPreviewBehaviour';
import './Shared/Infrastructure/Behaviours/SortableBehaviour';
import './Shared/Infrastructure/Behaviours/CustomSelectsBehaviour';
import './Shared/Infrastructure/Behaviours/ChangablesBehaviour';
import './Shared/Infrastructure/Behaviours/TabsBehaviour';
import './Shared/Infrastructure/Behaviours/ToggleBehaviour';
import './Shared/Infrastructure/Behaviours/Component/ComponentBehavior';
import './Shared/Infrastructure/Behaviours/Widgets/WidgetBehavior';
import './Shared/Infrastructure/Behaviours/ScrollbarBehaviour';
import './Shared/Infrastructure/Behaviours/PaymentChannelAmountBehaviour';
import './Shared/Infrastructure/Behaviours/VoximplantCallBehaviour';
import './Shared/Infrastructure/Behaviours/CustomFileBehaviour';
import './Shared/Infrastructure/Behaviours/FileControlsBehaviour';
import './Shared/Components/BetItemController';
import './Shared/Widgets/WidgetController';
import './Shared/Widgets/HotEvents/HotEventsWidgetController';
import './Shared/Widgets/Reviews/ReviewWidgetController';
import './Shared/Widgets/Interesting/InterestingWidgetController';
import './Shared/Infrastructure/Behaviours/Reviews/UseBettingCartBehaviour';
import './Shared/Modules/TimeZone.js';
import './Shared/Infrastructure/Controls';
import './Shared/app.js';

import './Shared/cps/passport-data';
import './Shared/cps/reg-form';
import './Shared/Modules/AwesomeScrollbar.js';
import './Shared/Modules/AwesomeHorizontalScrollbar.js';
import './Shared/Modules/Tooltip.js';
import './Shared/startup.js';
